import http from 'axios'

export default {  
  getValeursFiltresApport: (username, anneeRecolte, codeGraineRs3) => {
    return http.get(`/web/v1/${username}/filtres-apports/${anneeRecolte}?codeIdaRs3=${codeGraineRs3}`)
  }
}
